import Alpine from "alpinejs";

import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "tippy.js/animations/scale.css";

const tooltip: Alpine.DirectiveCallback = (el, { expression }, { cleanup }) => {
  if (expression === undefined || expression.length === 0) {
    return;
  }

  const item = tippy(el, {
    content: expression,
    theme: "light",
    allowHTML: true,
  });

  cleanup(() => {
    item.destroy();
  });
};

export default tooltip;
